import { render, staticRenderFns } from "./ManageDialog.vue?vue&type=template&id=6ab3577b&scoped=true&"
import script from "./ManageDialog.vue?vue&type=script&lang=ts&"
export * from "./ManageDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ManageDialog.vue?vue&type=style&index=0&id=6ab3577b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab3577b",
  null
  
)

export default component.exports